import '../../scss/pages/experience.scss';
import 'swiper/css/bundle';
import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

//js import
import Swiper from 'swiper/bundle';


let expGallery=document.querySelectorAll('.experience-gallery__slider-wrapper');
let experienceMenuLinks=document.querySelectorAll('.experience-menu-link');
let sectionExperienceMenu= document.querySelector('#experience-menu');

for (const experienceMenuLink of experienceMenuLinks) {
    experienceMenuLink.addEventListener('click', function onClick() {
        console.log(experienceMenuLink.dataset.bg);
        //sectionExperienceMenu.style.background=experienceMenuLink.dataset.bg

    });
}

var swiper = new Swiper(".experience-gallery__slider", {
	speed:1000,
    spaceBetween: 16,
    slidesPerView: 1,
    // centeredSlides: false,
    loop: false,
    navigation: {
        prevEl: ".experience-gallery__prev",
        nextEl: ".experience-gallery__next",
    },
    pagination: {
        el: ".experience-gallery__pagination",
        clickable:true
    },
    breakpoints: {
        320:{
            slidesPerView: 2,
        },
        480: {
            slidesPerView: 2,
        },
        768:{
            slidesPerView: 3,
            spaceBetween: 20,
        },
        992:{
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1024:{
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1440:{
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1600:{
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1920:{
            slidesPerView: 4,
            spaceBetween: 20,
        }
    }
});
window.onload = function() {
    for(var i = 1; i<=expGallery.length; i++) {
        lightGallery(document.getElementById('lightgallery'+ i), {
            plugins: [lgThumbnail],
            licenseKey: 'your_license_key',
            speed: 500,
            download: false,
            // ... other settings
        });
    }
}


